var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wkb-node-connections" }, [
    _c("h4", { staticClass: "wkb-inspector-section-heading" }, [
      _vm._v(" Top connections from " + _vm._s(_vm.nodeLabel) + " "),
    ]),
    _c("p", { staticClass: "wkb-node-connections-lead" }, [
      _vm._v(
        " Ranked candidates you can add, using your selected nodes and this node. "
      ),
    ]),
    _c("div", { staticClass: "wkb-node-connections-toolbar" }, [
      _c(
        "div",
        {
          staticClass: "wkb-node-connections-tabs",
          attrs: { role: "tablist", "aria-label": "Top connection types" },
        },
        _vm._l(_vm.targetTypes, function (targetType) {
          return _c(
            "button",
            {
              key: targetType,
              staticClass: "wkb-node-connections-tab",
              class: { "is-active": _vm.selectedTab === targetType },
              attrs: {
                id: _vm.tabId(targetType),
                type: "button",
                role: "tab",
                "aria-selected":
                  _vm.selectedTab === targetType ? "true" : "false",
                "aria-controls": _vm.panelId,
              },
              on: {
                click: function ($event) {
                  _vm.selectedTab = targetType
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.targetTypeLabel(targetType)) + " ")]
          )
        }),
        0
      ),
      _c("label", { staticClass: "wkb-node-connections-toggle" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.shownOnly,
              expression: "shownOnly",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.shownOnly)
              ? _vm._i(_vm.shownOnly, null) > -1
              : _vm.shownOnly,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.shownOnly,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.shownOnly = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.shownOnly = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.shownOnly = $$c
              }
            },
          },
        }),
        _vm._v(" Show only on graph "),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "wkb-node-connections-panel",
        attrs: {
          id: _vm.panelId,
          role: "tabpanel",
          "aria-labelledby": _vm.tabId(_vm.selectedTab),
        },
      },
      [
        _vm.isSelectedTabLoading
          ? _c("p", { staticClass: "wkb-inspector-note" }, [
              _vm._v(" Loading top connections… "),
            ])
          : _vm.selectedTabError
          ? _c(
              "p",
              { staticClass: "wkb-inspector-note wkb-inspector-note--warn" },
              [_vm._v(" " + _vm._s(_vm.selectedTabError) + " ")]
            )
          : _vm.visibleRows.length
          ? _c("WorkspaceEvidenceTable", {
              attrs: {
                rows: _vm.visibleRows,
                columns: _vm.tableColumns,
                "page-size": 10,
                "empty-note": _vm.emptyStateMessage,
                "pagination-label": "Top connections pages",
              },
              scopedSlots: _vm._u([
                {
                  key: "add",
                  fn: function ({ row }) {
                    return [
                      row.shown === "yes"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "wkb-inspector-mini-btn wkb-inspector-mini-btn--remove",
                              attrs: {
                                type: "button",
                                disabled: _vm.graphBusy,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onRemoveRow(row)
                                },
                              },
                            },
                            [_vm._v(" Remove ")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass:
                                "wkb-inspector-mini-btn wkb-inspector-mini-btn--add",
                              attrs: {
                                type: "button",
                                disabled: _vm.graphBusy,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onAddRow(row)
                                },
                              },
                            },
                            [_vm._v(" Add ")]
                          ),
                    ]
                  },
                },
              ]),
            })
          : _c("p", { staticClass: "wkb-inspector-note" }, [
              _vm._v(_vm._s(_vm.emptyStateMessage)),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }